function cartBubbleCount(count)  {
    const cartBubblesVisible = document.querySelectorAll('.cart-link__bubble');

    cartBubblesVisible.forEach(bubble => {
        bubble.innerHTML = count;
    })

    const cartDrawerItems = document.querySelector('.cart-drawer--count');
    if(cartDrawerItems) {
        let countText = ' items';
        if(count === 1) {
            countText = ' item';
        }
        cartDrawerItems.textContent = '(' + count + countText + ')';
    }
}

const fetchCart = async (e) => {
    try {
        const res = await fetch('/cart.js');
        const data = await res.json();
        if (res.ok) return data;
    } catch (error) {
        console.log(error);
        return null
    }
}

function isMobile() {
    let windowWidth = window.innerWidth;
    if(windowWidth < 769) {
        return true
    } else {
        return false;
    }
}

const debounce = (f, delay) => {
    let timer = 0;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => f.apply(this, args), delay);
    }
}

// Custom sliders
const sliderReinitCallback = ([entry]) => {
    const flkty = Flickity.data(entry.target);
    if (flkty) flkty.resize();
}

const initMobileOnlySlider = (slider, args) => {
    let flickity;

    function initSlider() {
        flickity = new theme.Slideshow(slider, args);
    }

    function unload() {
        if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
        }
    }

    if (isMobile()) {
        initSlider();
    }

    window.addEventListener('resize', function(event) {
        if(isMobile()) {
            initSlider();
        } else {
            unload();
        }
    }, true);
}

const initCustomSlider = (slider, isCustom) => {
    let args = slider.dataset.args;
    const mobileOnly = slider.dataset.mobileOnly;
    if(args) {
        args = JSON.parse(args);
    }
    if(mobileOnly == "true") {
        initMobileOnlySlider(slider, args);
    } else {
        let flickity = new Flickity(slider, args);
        const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
        reinitFlickitySlider.observe(slider);
        if(isCustom) {
            let thisSlider = slider.closest('.shopify-section');
            let slideNumber = thisSlider.querySelector('.slide-number');
            let totalSlide = thisSlider.querySelector('.custom-slider-counter');
            let previousBtn = thisSlider.querySelector('.custom-slider--previous');
            let nextBtn = thisSlider.querySelector('.custom-slider--next');
            
            flickity.on( 'change', function( index ) {
                let currentSlide = index + 1;
                if ( slideNumber ) {
                    slideNumber.innerHTML = currentSlide;
                    if ( currentSlide == 1 ) {
                        previousBtn.classList.add('disabled');
                        if(currentSlide < totalSlide.dataset.total) {
                            nextBtn.classList.remove('disabled');
                        }
                    } else if ( currentSlide == totalSlide.dataset.total ) {
                        nextBtn.classList.add('disabled');
                        previousBtn.classList.remove('disabled');
                    } else {
                        nextBtn.classList.remove('disabled');
                        previousBtn.classList.remove('disabled');
                    }
                }
            })
        }
    }
}

const script_init = e => { 

    const customSliders = document.querySelectorAll('.custom-slider-js');

    if(customSliders.length) {
        customSliders.forEach(slider => {
            initCustomSlider(slider, true);

            let customPrev = slider.closest('.shopify-section').querySelector('.custom-slider--previous-js');
            let customNext = slider.closest('.shopify-section').querySelector('.custom-slider--next-js');
            
            if ( customPrev ) {
                customPrev.addEventListener('click', () => {
                    slider.closest('.shopify-section').querySelector('.custom-slider--arrows_hidden > .flickity-previous').click();
                })
            }

            if ( customNext ) {
                customNext.addEventListener('click', () => {
                    slider.closest('.shopify-section').querySelector('.custom-slider--arrows_hidden > .flickity-next').click();
                });
            }
        })
    }

    // Megamenu
    const menu = document.querySelectorAll('.site-nav__dropdown-link');
    const megamenu_images = document.querySelectorAll('.megamenu-image');

    menu.forEach(link => {
        link.addEventListener('mouseover', () => {
            let dataId = link.dataset.id;
            let getImage = document.querySelector('.megamenu-image[data-id="'+ dataId +'"]');

            megamenu_images.forEach(image => {
                image.classList.remove('active')
            })

            if ( dataId && getImage ) {
                getImage.classList.add('active');
            }
        });
    })

    // Sub collection slider
    const subCollectionSlider = document.querySelector('.sub-collection-slider');
    if(subCollectionSlider) {
        initCustomSlider(subCollectionSlider);
    }

    initProductGridImageSliders();

    // const tabNavButtons = document.querySelectorAll('.tab-nav_button');
    // const tabContents = document.querySelectorAll('.tab-content');

    // tabNavButtons.forEach(button => {
    //     button.addEventListener('click', () => {
    //         let dataTab = button.dataset.tab;
    //         const dataTabContent = document.querySelectorAll('.tab-content[data-tab="' + dataTab + '"]');

    //         tabNavButtons.forEach(buttons => {
    //             buttons.classList.remove('active')
    //         })

    //         tabContents.forEach(buttons => {
    //             buttons.classList.remove('active')
    //         })

    //         button.classList.add('active');

    //         dataTabContent.forEach(content => {
    //             content.classList.add('active');
    //         });
    //     })
    // });

    // PDP image scroller
    const thumbScoller = document.querySelector('.product__thumbs--scroller');
    const imageMain = document.querySelector('.product-image-main');

    let windowWidth = window.innerWidth;

    if( windowWidth > 768) {
        
        if ( thumbScoller && imageMain ) {
            let setMaxHeight = parseInt(imageMain.clientHeight) - parseInt(30);
            thumbScoller.style.maxHeight = setMaxHeight + 'px';
        }
    }

    // FAQ Search
    const faqSearchInputs = document.querySelectorAll('[data-search-faqs-value]');
    if(faqSearchInputs) {
        faqSearchInputs.forEach(input => {
            input.addEventListener('input', function(e) {
                const searchQuery = this.value.toLowerCase();
                const onInput = debounce(getFaqSearchResults, 1000);
                onInput(searchQuery);
            })
        })
    }

    const getFaqSearchResults = (query) => {
        const parents = document.querySelectorAll('[data-faq-search-parent]');
        const faqItems = document.querySelectorAll('[data-faq-search]');
        const noResultsEl = document.querySelector('[data-search-faqs-no-results]');
        if(query) {
            // Show all when searching
            document.querySelectorAll('.faq-category').forEach(categories => {
                categories.classList.add('is_searching');
            });

            // Hide all if has class of hide-when-searching
            document.querySelectorAll('.hide-when-searching').forEach(categories => {
                categories.classList.add('is_searching');
            });
            
            faqItems.forEach(item => {
                const text = item.textContent.toLowerCase();
                if (text.includes(query)) {
                    item.classList.remove('hide');
                    item.classList.add('search-visible');
                } else {
                    item.classList.add('hide');
                    item.classList.remove('search-visible');
                }
            })
            
            parents.forEach(item => {
                const activeSearchResults = item.querySelectorAll('.search-visible');
                if(activeSearchResults.length) {
                    item.classList.remove('hide');
                    item.querySelector('[data-faq-search-parent-btn]:not(.is-open)')?.click();
                } else {
                    item.classList.add('hide');
                    item.querySelector('[data-faq-search-parent-btn].is-open')?.click();
                }
            })
        
            const activeResults = document.querySelectorAll('.search-visible');    
            if(activeResults.length) {
                noResultsEl.classList.add('hide');
            } else {
                noResultsEl.classList.remove('hide');
            }
        } else {
            // Remove all searching not whithin the selected category
            document.querySelectorAll('.faq-category').forEach(categories => {
                categories.classList.remove('is_searching');
            });

            // Show all if has class hide-when-searching
            document.querySelectorAll('.hide-when-searching').forEach(categories => {
                categories.classList.remove('is_searching');
            });

            parents.forEach(item => {
                item.classList.remove('hide');
                item.querySelector('[data-faq-search-parent-btn].is-open')?.click();
            })

            faqItems.forEach(item => {
                item.classList.remove('hide');
            })
          
            noResultsEl.classList.add('hide');
        }
    }

    const btnCategory = document.querySelectorAll('.btn--icon-js_category')

    btnCategory.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            // Remove all active button
            btnCategory.forEach(btns => {
                btns.classList.remove('active')
            });

            // Add active button
            btn.classList.add('active')

            // Hide all if has class hide-when-searching
            document.querySelectorAll('.hide-when-searching').forEach(categories => {
                categories.classList.add('hide');
            });

            // Hide all categories
            document.querySelectorAll('.faq-category').forEach(categories => {
                categories.classList.remove('active');
            });
            
            // Show selected category
            document.querySelectorAll('.faq-category[data-category="' + btn.dataset.category + '"]').forEach(categories => {
                categories.classList.add('active');
            })

            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: parseFloat(document.querySelector(btn.getAttribute('href')).offsetTop) - parseFloat(document.querySelector('#SiteHeader').offsetHeight) - parseFloat(20),
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', script_init, false);

document.addEventListener('cart:updated', function(evt) {
    if(evt.detail.cart.item_count) {
        cartBubbleCount(evt.detail.cart.item_count);
    }
});

document.addEventListener('ajaxProduct:added', async function(evt) {
    const cartJson = await fetchCart();
    cartBubbleCount(cartJson.item_count);
});

document.addEventListener('custom-slider', () => {
    const customSlidersRecent = document.querySelectorAll('.custom-slider-js_recent');

    customSlidersRecent.forEach(slider => {
        initCustomSlider(slider, true);
    })
});

// Cart remove
document.addEventListener('click', (e) => {
    if(e.target.classList.contains('js-remove-item')) {
        const key = e.target.dataset.key;

        let updates = {
            [key]: 0
          };
          
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          })
          .then(response => response.json())
          .then(data => {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: data } }));
          })
          .catch((error) => {
            console.error('Error:', error);
          });

    }
})

// Product grid image sliders

const initiatedProductGridImageSliders = [];

const initProductGridImageSliders = () => {
    const sliders = document.querySelectorAll('.product-grid-image-slider');
    if(sliders.length) {
        sliders.forEach(slider => {
            if(!initiatedProductGridImageSliders.includes(slider)) {
                initCustomSlider(slider);
                initiatedProductGridImageSliders.push(slider);
            }
        })
    }
}

document.addEventListener('collection:reloaded',initProductGridImageSliders);

class LoadMore extends HTMLElement {
    constructor(){
        super();

        this.action = this.dataset.action;
        this.baseUrl = this.dataset.url;
        this.totalPages = +this.dataset.totalPages;
        this.currentPage = +this.dataset.currentPage;
        this.gridTarget = document.querySelector(this.dataset.gridTarget);
        this.gridTargetClass = this.dataset.gridTarget;
        this.gridItemTargetClass = this.dataset.gridItemTarget;

        this.renderBtn();
        this.updateProductsShowing();
    }

    renderBtn() {
        let showBtn = false;

        if(this.action === "next" && this.totalPages > this.currentPage) {
        showBtn = true;
        }

        if(this.action === "previous" && this.currentPage !== 1) {
        showBtn = true;
        }

        if(showBtn) {
        let btnHtml = `
            <div class="load-more-wrap text-center">
            <button type="button" class="btn btn--tertiary text-uppercase">Load ${this.action === "next" ? "More" : "Previous"}</button>
            </div>
        `;
        this.innerHTML = btnHtml;
        this.registerBtnEvtListener();
        }
    }

    registerBtnEvtListener() {
        const btn = this.querySelector('.btn');
        btn.addEventListener('click', (e) => {
        this.fetchItems(e.target);
        })
    }

    getCurrentUrl() {
        let queryString = window.location.search;

        if(queryString) {
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.has('page')) {
            queryString = queryString.replace(`page=${urlParams.get('page')}`, '[page]');
        }
        return this.baseUrl + queryString;
        
        } else {
        return this.baseUrl;
        }
    }

    async fetchItems(btn) {
        btn.classList.add('btn--loading');

        let currentUrl = this.getCurrentUrl();
        let newPage = this.currentPage;

        if(this.action === "next") {
        newPage = this.currentPage + 1;
        }

        if(this.action === "previous") {
        newPage = this.currentPage - 1;
        }

        if(currentUrl.includes('[page]')) {
        currentUrl = currentUrl.replace('[page]', 'page=' + newPage);
        } else if(currentUrl.includes('?')) {
        currentUrl = currentUrl +'&page='+newPage;
        } else {
        currentUrl = currentUrl +'?page='+newPage;
        }

        try {
        const res = await fetch(currentUrl);
        const text = await res.text();

        if (res.ok) {
            this.renderItems(text);
        }
        } catch (error) {
        console.log(error);
        } finally {
        if((this.action === "next" && newPage >= this.totalPages) || (this.action === "previous" && newPage <= 1)) {
            btn.remove();
        } else {
            btn.classList.remove('btn--loading');
        }
        this.updatePageCount(newPage);
        window.history.pushState({page: newPage}, "", currentUrl);
        }
    }

    updatePageCount(newPage) {
        this.currentPage = newPage;
        this.setAttribute('data-current-page', newPage);
    }

    parseProductHTML(text) {
        const html = document.createElement('div');
        html.innerHTML = text;

        return {
        items: html.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}`)
        }
    }

    renderItems(text) {
        const markup = this.parseProductHTML(text);
        if(this.action === "next") {
        this.gridTarget.append(...markup.items);
        }
        if(this.action === "previous") {
        this.gridTarget.prepend(...markup.items);
        }

        this.updateProductsShowing();

        if (window.AOS) { AOS.refreshHard() }
        document.dispatchEvent(new CustomEvent("collection:reloaded"));

    }

    updateProductsShowing() {
        const el = document.querySelector('.collection-results-count');
        if(el) {
            const items = document.querySelectorAll(`${this.gridTargetClass} ${this.gridItemTargetClass}`);
            const span = el.querySelector('span');
            span.textContent = items.length;
        }
    }
}

if (!customElements.get('load-more')) {
    customElements.define('load-more', LoadMore);
}

const addProductToCart = async (variantId, qty, btn) => {
    if(!qty) {
        qty = 1;
    }
    if(btn) {
        btn.classList.add('btn--loading');
    }
    try {
        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              { id: variantId, quantity: qty }
            ]
          })
        });
        const data = await res.json();
  
        if (res.ok){
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data }
          }));
          
        }
        if (res.status === 422) {
          this.error(data);
        }
      } catch (error) {
        this.error(error);
      } finally {
        if(btn) {
            btn.classList.remove('btn--loading');
        }
      }
} 

class CartUpsell extends HTMLElement {
    constructor(){
        super();

        this.slides = this.querySelectorAll('.cart-upsell-slide');
        this.addToCartBtns = this.querySelectorAll('.js-quick-add');
        this.upsellSlider = this.querySelector('.cart-upsell-slider');
        this.cart;
        this.flickity;
    }

    connectedCallback() {
        if(this.slides.length) {
            if(this.slides.length > 2) {    
                if(this.upsellSlider) {   
                    let args = {
                        "groupCells": false,
                        "pageDots": false, 
                        "prevNextButtons": false,
                        "cellAlign": "left",
                        "wrapAround": false,
                        "contain": true
                    }
                    this.flickity = new Flickity(this.upsellSlider, args);
                    const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
                    reinitFlickitySlider.observe(this.upsellSlider);
                }
            }

            if(this.addToCartBtns.length) {
                this.addToCartBtns.forEach(btn => {
                    btn.addEventListener('click', (e) => {
                        const variantId = e.target.dataset.variantId;
                        addProductToCart(variantId, 1, btn);
                    })
                })
            }

            document.addEventListener('cart:updated', (e) => {
                this.cart = e.detail.cart;
                this.checkInCart();
            });
            
            document.addEventListener('ajaxProduct:added', async (e) => {
                fetchCart().then(cart => {
                    this.cart = cart;
                    this.checkInCart();
                })
            });

        } else {
            this.classList.add('hide');
        }

    }

    checkInCart() {
        let refreshSlider = false;
        this.slides.forEach(prod => {
            const prodId = prod.dataset.productId;
            if(this.cart.items) {
                this.cart.items.forEach(item => {
                    if(item.product_id == prodId) {
                        prod.remove();
                        refreshSlider = true;
                    }
                })
            }
        })
        this.slides = this.querySelectorAll('.cart-upsell-slide');
        if(this.slides.length) {
            if(refreshSlider) {
                this.flickity.resize();
            }
        } else {
            this.classList.add('hide');
        }
    }

}

if (!customElements.get('cart-upsell')) {
    customElements.define('cart-upsell', CartUpsell);
}

document.addEventListener('click', function(event) {
    if (event.target.classList.contains('tab-nav_button') ) {
        let tabNavButtons = event.target.closest('.tabs').querySelectorAll('.tab-nav_button');
        let tabContents = event.target.closest('.tabs').querySelectorAll('.tab-content');
        let dataTab = event.target.dataset.tab;
        let dataTabContent = event.target.closest('.tabs').querySelectorAll('.tab-content[data-tab="' + dataTab + '"]');
        
        tabNavButtons.forEach(buttons => {
            buttons.classList.remove('active')
        })

        tabContents.forEach(buttons => {
            buttons.classList.remove('active')
        })

        event.target.classList.add('active');

        dataTabContent.forEach(content => {
            content.classList.add('active');
        });
    } else if (event.target.classList.contains('accordion-button') ) {
        let accordions = event.target.closest('.accordions').querySelectorAll('.accordion');

        accordions.forEach(accordion => {
            accordion.classList.remove('active');
        })

        event.target.closest('.accordion').classList.add('active');
    } else if (event.target.classList.contains('dropdown-heading') ) {
        event.target.closest('.dropdown').classList.toggle('active');
    } else if (event.target.classList.contains('dropdown-list_button') ) {
        event.target.closest('.dropdown').classList.remove('active')
        event.target.closest('.dropdown').querySelector('.heading').innerHTML = event.target.dataset.dropdownHeading;

        document.querySelectorAll('.accordion').forEach(accordion => {
            accordion.classList.remove('active');
        })

        document.querySelectorAll('.accordion[data-accordion="' + event.target.dataset.dropdown + '"]').forEach(selectedAccordions => {
            selectedAccordions.classList.add('active');
        })
    } else if (event.target.classList.contains('btn--modal_close') ) {
        event.target.closest('.basic-modal').classList.remove('active');
        event.target.closest('.basic-modal').style.display = 'none';
        document.querySelector('body').classList.remove('basic-modal_active');
    } else if (event.target.getAttribute('href') == '#contact-modal' ) {
        document.querySelector('.basic-modal').classList.add('active');
        document.querySelector('body').classList.add('basic-modal_active');
    }
})